import React, {PropTypes} from 'react';
import LinkOrSpan from '../../../../../shared/components/link-or-span';
import RecoveryPercentageIcon from '../../recovery-percentage-icon';
import SelectedPostingDate from '../../../state/selected-posting-date';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import {buildCurrency} from '../../../../../shared/services/build-number';

const LocationsBody = (props, context) =>
    <section className='locations-body'>
        {props.locations.map((location, index) =>
            <section
                className='locations-body-item'
                key={index}
            >
                <span>{location.subAccount.account}</span>
                <span>
                    <LinkOrSpan
                        actualValue={location.approvedClaimCount}
                        displayValue={location.approvedClaimCount}
                        link={`/reimbursement-summary/claims?leadAccount=${location.subAccount.leadAccount}&city=${location.subAccount.location.city}&account=${location.subAccount.account}&postingDateFrom=${props.selectedPostingDate.postingDateFrom}&postingDateTo=${props.selectedPostingDate.postingDateTo}&leadAccountDisplayName=${encodeURIComponent(props.leadAccountName)}`}
                    />
                </span>
                <span>
                    {location.recoveryPercentage}
                    <RecoveryPercentageIcon recoveryPercentage={location.recoveryPercentage}/>
                </span>
                <span>
                    <LinkOrSpan
                        actualValue={location.totalUnpaid}
                        displayValue={buildCurrency(location.totalUnpaid, context.user.settings.general.decimalFormat.key)}
                        link={`/reimbursement-summary/claims?leadAccount=${props.leadAccount}&city=${location.subAccount.location.city}&account=${location.subAccount.account}&postingDateFrom=${props.selectedPostingDate.postingDateFrom}&postingDateTo=${props.selectedPostingDate.postingDateTo}&leadAccountDisplayName=${encodeURIComponent(props.leadAccountName)}&unpaidFilter=totalUnpaid`}
                    />
                </span>
            </section>
        )}
    </section>;

LocationsBody.displayName = 'LocationsBody';
LocationsBody.propTypes = {
    leadAccount: PropTypes.string.isRequired,
    leadAccountName: PropTypes.string.isRequired,
    locations: PropTypes.array.isRequired,
    selectedPostingDate: PropTypes.instanceOf(SelectedPostingDate)
};
LocationsBody.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};

export default LocationsBody;



// WEBPACK FOOTER //
// ./src/reimbursement-summary/summary/components/reimbursement-summary-main/locations-accordion/locations-body.js